export default [
    { value: 'true', label: 'Active' },
    { value: 'false', label: 'Inactive' }
]